import clsx from "clsx";
import { FC, HTMLAttributes, PropsWithChildren } from "react";

type HeadingProps = PropsWithChildren<
  HTMLAttributes<HTMLDivElement> & {
    size?: "sm" | "md" | "lg" | "xl" | "2xl";
    styles?: object;
  }
>;
export const Heading: FC<HeadingProps> = ({
  className,
  children,
  size = "md",
  ...props
}) => {
  return (
    <div
      className={clsx(
        {
          "text-[28px] md:text-[44px]": size === "sm",
          "text-[24px] md:text-[54px]": size === "md",
          "text-[36px] md:text-[60px]": size === "lg",
          "text-[28px] md:text-[72px]": size === "xl",
          "text-[34px] font-400 leading-[100%] md:text-[100px]": size === "2xl",
        },
        "intelli-heading font-400 font-calSans leading-[normal]",
        className
      )}
      {...props}
    >
      {children}
    </div>
  );
};
